function init_forecast_widget(w, filters) {
    var $ = jQuery.noConflict();

    var graph_w = w.find('.graph-wrapper');
    graph_w.isLoading();

    widgetRequest('/widgets/forecast/getData', filters).then((data) => {
        graph_w.doneLoading();

        var datasets = data.datasets;

        var config = {
            type: 'line',
            data: {
                labels: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
                datasets: datasets
            },
            options: {
                responsive: true,
                legend: {
                    display: false,
                },
                title:{
                    display:false,
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function(tooltipItems, data) {
                            return '€ '+tooltipItems.yLabel;
                        }
                    }
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: false,
                            labelString: 'Maand'
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: false,
                            labelString: 'Bedrag'
                        },
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: function(value, index, values) {
                                return '€ ' + value;
                            }
                        }
                    }]
                }
            }
        };

        w.find('canvas').replaceWith('<canvas></canvas>');

        if(w.find('canvas')[0]) {
            var ctx = w.find('canvas')[0].getContext("2d");
            var myLine = new Chart(ctx, config);

        }
    });
}